module.exports = __webpack_public_path__ + "static/img/banner2.5f0e04c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner2.jpg
// module id = y5LZ
// module chunks = 1